document.addEventListener('DOMContentLoaded', function() {
(function () {

var ML_PER_G   = 1.07;
var NA_PER_30G = 200;
var K_PER_30G  = 50;
var PRERACE_MIN = -15;

var RACES = {
  run:   { halfmarathon:{dist:21.1,label:'Half Marathon'}, marathon:{dist:42.195,label:'Marathon'}, custom_run:{dist:null,label:'Custom'} },
  cycle: { custom_cycle:{dist:null,label:'Cycling'} },
  tri:   { olympic:{dist:40,label:'Olympic (bike 40km)'}, half:{dist:90,label:'70.3 (bike 90km)'}, ironman:{dist:180,label:'Ironman (bike 180km)'} }
};

var TOOLTIPS = {
  strategy: "Negative split means you run the second half slightly faster than the first. Your first fuel dose is delayed slightly.",
  aid: "Enter the km marker of each aid station. Your fuel doses will be placed 300m before each station to allow you to wash it down.",
  temp: "Heat increases sweat rate and electrolyte loss. We adjust your carbohydrate target to match your body's capacity in the heat.",
  gut: "How many grams of carbohydrate your gut can absorb per hour during racing. Build this up gradually in training."
};

var css =
"@import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@300;400;500&family=Outfit:wght@200;300;400;500&display=swap');\n"+
"*,*::before,*::after{margin:0;padding:0;box-sizing:border-box}\n"+
":host{\n"+
"  --bg:#080808;--bg2:#101010;--bg3:#161616;\n"+
"  --line:rgba(255,255,255,0.06);--line2:rgba(255,255,255,0.12);\n"+
"  --text:#EDEAE4;--muted:rgba(237,234,228,0.4);--dim:rgba(237,234,228,0.15);\n"+
"  display:block;font-family:'Outfit',sans-serif;font-weight:300;\n"+
"  background:var(--bg);color:var(--text);line-height:1.6;-webkit-font-smoothing:antialiased;\n"+
"}\n"+
".page{max-width:680px;margin:0 auto;padding:56px 32px 120px;width:100%}\n"+
"\n"+
"/* Header */\n"+
".brand{font-family:'DM Mono',monospace;font-size:9px;letter-spacing:.22em;text-transform:uppercase;color:var(--muted);margin-bottom:20px;display:flex;align-items:center;gap:12px}\n"+
".brand::after{content:'';flex:1;height:1px;background:var(--line)}\n"+
".page-title{font-family:'DM Mono',monospace;font-size:clamp(11px,2vw,13px);letter-spacing:.18em;text-transform:uppercase;color:var(--text);font-weight:500;margin-bottom:52px;line-height:1.2}\n"+
"\n"+
"/* Form */\n"+
".form-wrap{display:flex;flex-direction:column;gap:1px;background:var(--line);width:100%;margin-bottom:1px}\n"+
".fg{background:var(--bg2);padding:20px 24px;min-width:0}\n"+
".fg.row2{display:grid;grid-template-columns:1fr 1fr;gap:1px;background:transparent;padding:0}\n"+
".fg.row2 .fg{background:var(--bg2)}\n"+
".flabel-wrap{display:flex;align-items:center;gap:8px;margin-bottom:12px}\n"+
".flabel{font-family:'DM Mono',monospace;font-size:9px;letter-spacing:.2em;text-transform:uppercase;color:var(--muted)}\n"+
"\n"+
"/* Tooltip */\n"+
".tip-wrap{position:relative;display:inline-flex}\n"+
".tip-btn{all:unset;width:14px;height:14px;border-radius:50%;border:1px solid var(--muted);font-family:'DM Mono',monospace;font-size:8px;color:var(--muted);cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all .12s;line-height:1}\n"+
".tip-btn:hover{border-color:var(--text);color:var(--text)}\n"+
".tip-box{display:none;position:absolute;top:calc(100% + 8px);left:0;z-index:99;background:var(--bg3);border:1px solid var(--line2);padding:10px 14px;font-size:11px;color:var(--muted);line-height:1.6;width:240px;pointer-events:none}\n"+
".tip-box.show{display:block}\n"+
"\n"+
"/* Seg buttons */\n"+
".seg{display:flex;flex-wrap:wrap;width:100%}\n"+
".seg button{all:unset;box-sizing:border-box;border:1px solid var(--line);color:var(--muted);font-family:'Outfit',sans-serif;font-size:12px;font-weight:400;padding:10px 14px;cursor:pointer;text-align:center;transition:all .12s;white-space:nowrap;margin-right:-1px;margin-bottom:-1px;min-width:0;flex-shrink:1}\n"+
".seg button:hover{border-color:var(--line2);color:var(--text)}\n"+
".seg button.on{background:var(--text);border-color:var(--text);color:var(--bg);font-weight:500;z-index:1;position:relative}\n"+
"\n"+
"/* Inputs */\n"+
"input[type=text],input[type=number]{all:unset;display:block;width:100%;background:transparent;border-bottom:1px solid var(--line2);color:var(--text);font-family:'DM Mono',monospace;font-size:20px;font-weight:300;padding:6px 0;transition:border-color .15s}\n"+
"input[type=text]:focus,input[type=number]:focus{border-color:var(--text);outline:none}\n"+
"input[type=number]{-moz-appearance:textfield}\n"+
"input[type=number]::-webkit-outer-spin-button,input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}\n"+
"input[type=date]{display:block;width:100%;background:transparent;border:none;border-bottom:1px solid var(--line2);color:var(--text);font-family:'DM Mono',monospace;font-size:18px;font-weight:300;padding:6px 0;transition:border-color .15s;outline:none;border-radius:0;min-height:36px;cursor:pointer}\n"+
"input[type=date]:focus{border-color:var(--text)}\n"+
"input[type=date]::-webkit-calendar-picker-indicator{filter:invert(.5);cursor:pointer}\n"+
".time-row{display:flex;align-items:center;gap:6px;flex-wrap:nowrap;width:100%}\n"+
".time-in{width:44px!important;text-align:center;font-size:20px;flex-shrink:0}\n"+
".tsep{font-family:'DM Mono',monospace;font-size:16px;color:var(--muted);flex-shrink:0}\n"+
".hint-sm{font-family:'DM Mono',monospace;font-size:9px;color:var(--dim);margin-top:7px;display:block}\n"+
"\n"+
"/* Aid tags */\n"+
".aid-list{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:10px;min-height:4px}\n"+
".aid-tag{font-family:'DM Mono',monospace;font-size:10px;color:var(--muted);border:1px solid var(--line2);padding:4px 10px;display:flex;align-items:center;gap:6px}\n"+
".aid-tag button{all:unset;color:var(--dim);cursor:pointer;font-size:12px;line-height:1;transition:color .12s}\n"+
".aid-tag button:hover{color:var(--text)}\n"+
".aid-add{display:flex;gap:8px;align-items:center;width:100%}\n"+
".aid-add input{font-size:16px!important;width:64px!important;flex-shrink:0}\n"+
".btn-add{all:unset;box-sizing:border-box;font-family:'DM Mono',monospace;font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:var(--muted);border:1px solid var(--line2);padding:7px 16px;cursor:pointer;transition:all .12s;white-space:nowrap;flex-shrink:0}\n"+
".btn-add:hover{color:var(--text);border-color:var(--line2)}\n"+
"\n"+
"/* Compute */\n"+
".btn-compute{all:unset;box-sizing:border-box;display:block;width:100%;background:var(--text);color:var(--bg);font-family:'DM Mono',monospace;font-size:11px;font-weight:500;letter-spacing:.14em;text-transform:uppercase;padding:22px;cursor:pointer;text-align:center;transition:opacity .15s;margin-top:1px}\n"+
".btn-compute:hover{opacity:.88}\n"+
"\n"+
"/* Results */\n"+
"#nl-results{display:none;margin-top:64px}\n"+
".res-topbar{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:40px;padding-bottom:20px;border-bottom:1px solid var(--line);flex-wrap:wrap;gap:12px}\n"+
".res-title{font-weight:200;font-size:20px;letter-spacing:-.02em;line-height:1.25}\n"+
".res-subtitle{font-family:'DM Mono',monospace;font-size:9px;color:var(--muted);margin-top:5px;letter-spacing:.05em}\n"+
".action-row{display:flex;gap:8px;flex-wrap:wrap}\n"+
".btn-act{all:unset;box-sizing:border-box;font-family:'DM Mono',monospace;font-size:9px;letter-spacing:.14em;text-transform:uppercase;color:var(--muted);border:1px solid var(--line);padding:8px 14px;cursor:pointer;transition:all .12s}\n"+
".btn-act:hover{color:var(--text);border-color:var(--line2)}\n"+
"\n"+
"/* Warning */\n"+
".warn-box{display:none;border:1px solid rgba(255,255,255,0.12);background:rgba(255,255,255,0.03);padding:14px 20px;font-size:12px;color:var(--muted);line-height:1.7;margin-bottom:32px}\n"+
".warn-box.show{display:block}\n"+
".warn-box strong{color:var(--text);font-weight:500}\n"+
"\n"+
"/* Stats grid — 3 cols, 2 rows */\n"+
".stats-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1px;background:var(--line);margin-bottom:40px;width:100%}\n"+
".stat-item{background:var(--bg2);padding:20px 16px}\n"+
".stat-val{font-family:'DM Mono',monospace;font-size:22px;font-weight:300;color:var(--text);letter-spacing:-.02em;line-height:1;margin-bottom:6px}\n"+
".stat-lbl{font-family:'DM Mono',monospace;font-size:7px;letter-spacing:.14em;color:var(--muted);text-transform:uppercase;line-height:1.5}\n"+
"\n"+
"/* Schedule */\n"+
".schedule-label{font-family:'DM Mono',monospace;font-size:9px;letter-spacing:.2em;text-transform:uppercase;color:var(--muted);margin-bottom:20px}\n"+
".fuel-table{width:100%;border-collapse:collapse}\n"+
".fuel-table th{font-family:'DM Mono',monospace;font-size:8px;letter-spacing:.16em;text-transform:uppercase;color:var(--dim);padding:0 0 14px;text-align:left;border-bottom:1px solid var(--line)}\n"+
".fuel-table th:first-child{width:18px;padding-right:14px}\n"+
".fuel-table th.th-time{width:72px}\n"+
".fuel-table th.th-km{width:54px}\n"+
".fuel-table td{padding:16px 0;border-bottom:1px solid var(--line);vertical-align:middle;color:var(--text)}\n"+
".fuel-table td:first-child{padding-right:14px;width:18px;vertical-align:middle}\n"+
".fuel-table td.td-time{font-family:'DM Mono',monospace;font-size:11px;color:var(--muted);white-space:nowrap;padding-right:16px;vertical-align:middle}\n"+
".fuel-table td.td-km{font-family:'DM Mono',monospace;font-size:10px;color:var(--dim);white-space:nowrap;padding-right:16px;vertical-align:middle}\n"+
".fuel-table td.td-main{font-size:13px;vertical-align:middle}\n"+
".fuel-table .main-line1{color:var(--text);font-size:13px;font-weight:400;display:block;margin-bottom:3px}\n"+
".fuel-table .main-line2{font-family:'DM Mono',monospace;font-size:10px;color:var(--muted);display:block}\n"+
".fuel-table .row-start td,.fuel-table .row-finish td{padding:12px 0}\n"+
".fuel-table .row-start .main-line1,.fuel-table .row-finish .main-line1{color:var(--dim);font-size:12px;font-weight:300}\n"+
".fuel-table .row-aid .main-line1{color:var(--dim);font-size:11px;font-weight:300}\n"+
"\n"+
"/* Dot */\n"+
".dot-wrap{display:flex;align-items:center;justify-content:center}\n"+
".dot{width:7px;height:7px;border-radius:50%;background:var(--text);flex-shrink:0}\n"+
".dot.hollow{background:transparent;border:1.5px solid var(--muted)}\n"+
".dot.sm{width:4px;height:4px;background:var(--dim)}\n"+
"\n"+
"/* Water note */\n"+
".water-note{padding:16px 22px;background:var(--bg2);border:1px solid var(--line);font-size:12px;color:var(--muted);line-height:1.8;margin-top:32px}\n"+
".water-note strong{color:var(--text);font-weight:500}\n"+
"\n"+
"/* CTA */\n"+
".n47-cta{margin-top:1px;padding:20px 24px;background:var(--bg2);border:1px solid var(--line);display:flex;justify-content:space-between;align-items:center;gap:16px;flex-wrap:wrap}\n"+
".n47-cta-text{font-size:13px;color:var(--muted);line-height:1.6}\n"+
".n47-cta-text strong{color:var(--text);font-weight:500}\n"+
".btn-cta{all:unset;box-sizing:border-box;font-family:'DM Mono',monospace;font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:var(--bg);background:var(--text);padding:11px 22px;cursor:pointer;white-space:nowrap;transition:opacity .15s}\n"+
".btn-cta:hover{opacity:.85}\n"+
"\n"+
"/* Restore */\n"+
".restore-bar{display:none;margin-bottom:36px;padding:16px 22px;background:var(--bg2);border:1px solid var(--line);font-size:13px;color:var(--muted);justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap}\n"+
".restore-bar.show{display:flex}\n"+
".restore-bar strong{color:var(--text)}\n"+
".restore-btns{display:flex;gap:8px}\n"+
".btn-restore{all:unset;box-sizing:border-box;font-family:'DM Mono',monospace;font-size:9px;letter-spacing:.12em;text-transform:uppercase;border:1px solid var(--line2);color:var(--muted);padding:7px 14px;cursor:pointer;transition:all .12s}\n"+
".btn-restore:hover{color:var(--text)}\n"+
".btn-restore.primary{background:var(--text);color:var(--bg);border-color:var(--text)}\n"+
"\n"+
"/* Footer */\n"+
".footer{margin-top:72px;padding-top:20px;border-top:1px solid var(--line);font-family:'DM Mono',monospace;font-size:9px;letter-spacing:.14em;color:var(--dim);text-align:center}\n"+
"\n"+
"@media(max-width:600px){\n"+
"  .page{padding:32px 18px 80px}\n"+
"  .fg{padding:16px 18px}\n"+
"  .fg.row2{grid-template-columns:1fr}\n"+
"  .seg button{font-size:11px;padding:9px 10px}\n"+
"  .stats-grid{grid-template-columns:repeat(3,1fr)}\n"+
"  .stat-item{padding:16px 10px}\n"+
"  .stat-val{font-size:18px}\n"+
"  .stat-lbl{font-size:6px}\n"+
"  .res-topbar{flex-direction:column;gap:10px}\n"+
"  .res-title{font-size:17px}\n"+
"  .action-row{width:100%}\n"+
"  .btn-act{font-size:8px;padding:7px 10px}\n"+
"  .fuel-table td{padding:13px 0}\n"+
"  .fuel-table td.td-time{font-size:10px}\n"+
"  .fuel-table td.td-km{font-size:9px}\n"+
"  .fuel-table .main-line1{font-size:12px}\n"+
"  .fuel-table .main-line2{font-size:9px}\n"+
"  .time-in{width:36px!important;font-size:16px}\n"+
"  .tsep{font-size:14px}\n"+
"  input[type=date]{font-size:15px}\n"+
"  .tip-box{width:200px}\n"+
"  .n47-cta{flex-direction:column;align-items:flex-start}\n"+
"  .water-note{padding:12px 16px;font-size:11px}\n"+
"}\n"+
"\n"+
"@media print{\n"+
"  :host{background:#fff!important;color:#000!important}\n"+
"  .btn-compute,.action-row,.form-wrap,.n47-cta,.restore-bar,.footer{display:none!important}\n"+
"  #nl-results{display:block!important}\n"+
"  .page{padding:20px}\n"+
"  .res-title,.stat-val{color:#000!important}\n"+
"  .stat-item{background:#f5f5f5!important}\n"+
"  .fuel-table td,.fuel-table .main-line1{color:#000!important}\n"+
"  .fuel-table td.td-time,.fuel-table .main-line2,.fuel-table .row-start .main-line1,.fuel-table .row-finish .main-line1{color:#666!important}\n"+
"  .dot{background:#000!important}\n"+
"  .dot.hollow{background:transparent!important;border-color:#000!important}\n"+
"  .fuel-table td{border-bottom-color:#ddd!important}\n"+
"  .water-note{background:#f5f5f5!important;border-color:#ddd!important;color:#444!important}\n"+
"  .stats-grid{background:#ddd!important}\n"+
"}";

var html =
"<div class=\"page\">\n"+
"  <div class=\"restore-bar\" id=\"nl-restore\">\n"+
"    <span>Previous plan found — <strong id=\"nl-restore-name\"></strong></span>\n"+
"    <div class=\"restore-btns\">\n"+
"      <button class=\"btn-restore primary\" id=\"nl-restore-yes\">Continue</button>\n"+
"      <button class=\"btn-restore\" id=\"nl-restore-no\">Start over</button>\n"+
"    </div>\n"+
"  </div>\n"+
"  <div class=\"brand\">Nectar Lab</div>\n"+
"  <div class=\"page-title\">Personal Fuel Planner</div>\n"+
"  <div class=\"form-wrap\" id=\"nl-form\">\n"+
"    <div class=\"fg row2\">\n"+
"      <div class=\"fg\"><div class=\"flabel-wrap\"><span class=\"flabel\">Name</span></div><input type=\"text\" id=\"nl-name\" placeholder=\"First name\" /></div>\n"+
"      <div class=\"fg\"><div class=\"flabel-wrap\"><span class=\"flabel\">Race name</span></div><input type=\"text\" id=\"nl-racename\" placeholder=\"e.g. Copenhagen Marathon\" /></div>\n"+
"    </div>\n"+
"    <div class=\"fg row2\">\n"+
"      <div class=\"fg\"><div class=\"flabel-wrap\"><span class=\"flabel\">Race date</span></div><input type=\"date\" id=\"nl-date\" /></div>\n"+
"      <div class=\"fg\">\n"+
"        <div class=\"flabel-wrap\"><span class=\"flabel\">Target finish time</span></div>\n"+
"        <div class=\"time-row\">\n"+
"          <input type=\"number\" class=\"time-in\" id=\"nl-hours\" min=\"0\" max=\"30\" value=\"3\" />\n"+
"          <span class=\"tsep\">:</span>\n"+
"          <input type=\"number\" class=\"time-in\" id=\"nl-mins\" min=\"0\" max=\"59\" value=\"30\" />\n"+
"          <span style=\"font-family:'DM Mono',monospace;font-size:11px;color:var(--muted);margin-left:4px;flex-shrink:0\">HH:MM</span>\n"+
"        </div>\n"+
"        <span class=\"hint-sm\" id=\"nl-pace-hint\"></span>\n"+
"      </div>\n"+
"    </div>\n"+
"    <div class=\"fg\">\n"+
"      <div class=\"flabel-wrap\"><span class=\"flabel\">Sport</span></div>\n"+
"      <div class=\"seg\" id=\"nl-sport\">\n"+
"        <button data-val=\"run\" class=\"on\">Run</button>\n"+
"        <button data-val=\"cycle\">Cycling</button>\n"+
"        <button data-val=\"tri\">Triathlon</button>\n"+
"      </div>\n"+
"    </div>\n"+
"    <div class=\"fg\">\n"+
"      <div class=\"flabel-wrap\"><span class=\"flabel\">Distance</span></div>\n"+
"      <div class=\"seg\" id=\"nl-dist\">\n"+
"        <button data-val=\"halfmarathon\" data-sport=\"run\" class=\"on\">Half Marathon</button>\n"+
"        <button data-val=\"marathon\" data-sport=\"run\">Marathon</button>\n"+
"        <button data-val=\"custom_run\" data-sport=\"run\">Custom</button>\n"+
"        <button data-val=\"custom_cycle\" data-sport=\"cycle\" style=\"display:none\">Custom</button>\n"+
"        <button data-val=\"olympic\" data-sport=\"tri\" style=\"display:none\">Olympic</button>\n"+
"        <button data-val=\"half\" data-sport=\"tri\" style=\"display:none\">70.3</button>\n"+
"        <button data-val=\"ironman\" data-sport=\"tri\" style=\"display:none\">Ironman</button>\n"+
"      </div>\n"+
"      <div id=\"nl-custom-km-wrap\" style=\"display:none;margin-top:14px\">\n"+
"        <input type=\"number\" id=\"nl-custom-km\" min=\"1\" max=\"1200\" placeholder=\"Distance in km\" style=\"font-size:18px\" />\n"+
"      </div>\n"+
"    </div>\n"+
"    <div class=\"fg\">\n"+
"      <div class=\"flabel-wrap\">\n"+
"        <span class=\"flabel\">Race strategy</span>\n"+
"        <div class=\"tip-wrap\"><button class=\"tip-btn\" data-tip=\"strategy\">?</button><div class=\"tip-box\" id=\"tip-strategy\"></div></div>\n"+
"      </div>\n"+
"      <div class=\"seg\" id=\"nl-split\">\n"+
"        <button data-val=\"even\" class=\"on\">Even pace</button>\n"+
"        <button data-val=\"negative\">Negative split</button>\n"+
"      </div>\n"+
"    </div>\n"+
"    <div class=\"fg\">\n"+
"      <div class=\"flabel-wrap\">\n"+
"        <span class=\"flabel\">Aid stations</span>\n"+
"        <div class=\"tip-wrap\"><button class=\"tip-btn\" data-tip=\"aid\">?</button><div class=\"tip-box\" id=\"tip-aid\"></div></div>\n"+
"      </div>\n"+
"      <div class=\"aid-list\" id=\"nl-aid-list\"></div>\n"+
"      <div class=\"aid-add\">\n"+
"        <input type=\"number\" id=\"nl-aid-input\" min=\"0\" max=\"999\" placeholder=\"km\" />\n"+
"        <button class=\"btn-add\" id=\"nl-aid-btn\">+ Add</button>\n"+
"      </div>\n"+
"    </div>\n"+
"    <div class=\"fg\">\n"+
"      <div class=\"flabel-wrap\">\n"+
"        <span class=\"flabel\">Temperature</span>\n"+
"        <div class=\"tip-wrap\"><button class=\"tip-btn\" data-tip=\"temp\">?</button><div class=\"tip-box\" id=\"tip-temp\"></div></div>\n"+
"      </div>\n"+
"      <div class=\"seg\" id=\"nl-temp\">\n"+
"        <button data-val=\"cool\" class=\"on\">&lt; 20°C</button>\n"+
"        <button data-val=\"warm\">20–25°C</button>\n"+
"        <button data-val=\"hot\">&gt; 25°C</button>\n"+
"      </div>\n"+
"    </div>\n"+
"    <div class=\"fg\">\n"+
"      <div class=\"flabel-wrap\">\n"+
"        <span class=\"flabel\">Gut tolerance</span>\n"+
"        <div class=\"tip-wrap\"><button class=\"tip-btn\" data-tip=\"gut\">?</button><div class=\"tip-box\" id=\"tip-gut\"></div></div>\n"+
"      </div>\n"+
"      <div class=\"seg\" id=\"nl-gut\">\n"+
"        <button data-val=\"30\">Low (30g/hr)</button>\n"+
"        <button data-val=\"60\" class=\"on\">Medium (60g/hr)</button>\n"+
"        <button data-val=\"90\">High (90g/hr)</button>\n"+
"      </div>\n"+
"    </div>\n"+
"  </div>\n"+
"  <button class=\"btn-compute\" id=\"nl-compute\">Calculate Plan →</button>\n"+
"  <div id=\"nl-results\">\n"+
"    <div class=\"res-topbar\">\n"+
"      <div>\n"+
"        <div class=\"res-title\" id=\"nl-res-title\">—</div>\n"+
"        <div class=\"res-subtitle\" id=\"nl-res-subtitle\">—</div>\n"+
"      </div>\n"+
"      <div class=\"action-row\">\n"+
"        <button class=\"btn-act\" id=\"nl-btn-print\">Print</button>\n"+
"        <button class=\"btn-act\" id=\"nl-btn-copy\">Copy link</button>\n"+
"        <button class=\"btn-act\" id=\"nl-btn-download\">Download</button>\n"+
"      </div>\n"+
"    </div>\n"+
"    <div class=\"warn-box\" id=\"nl-warn\">\n"+
"      <strong>Note: Temperature adjustment exceeds your gut tolerance.</strong><br>\n"+
"      Due to race conditions, your recommended CHO intake is higher than your current gut tolerance. We recommend training your gut up to this level before race day.\n"+
"    </div>\n"+
"    <div class=\"stats-grid\">\n"+
"      <div class=\"stat-item\"><div class=\"stat-val\" id=\"nl-s-dist\">—</div><div class=\"stat-lbl\">Distance</div></div>\n"+
"      <div class=\"stat-item\"><div class=\"stat-val\" id=\"nl-s-time\">—</div><div class=\"stat-lbl\">Finish time</div></div>\n"+
"      <div class=\"stat-item\"><div class=\"stat-val\" id=\"nl-s-cho\">—</div><div class=\"stat-lbl\">g CHO / hr</div></div>\n"+
"      <div class=\"stat-item\"><div class=\"stat-val\" id=\"nl-t-cho\">—</div><div class=\"stat-lbl\">Total CHO</div></div>\n"+
"      <div class=\"stat-item\"><div class=\"stat-val\" id=\"nl-t-ml\">—</div><div class=\"stat-lbl\">ml N47 total</div></div>\n"+
"      <div class=\"stat-item\"><div class=\"stat-val\" id=\"nl-t-elec\">—</div><div class=\"stat-lbl\">Na + K / hr</div></div>\n"+
"    </div>\n"+
"    <div class=\"schedule-label\">Fuel Schedule</div>\n"+
"    <table class=\"fuel-table\">\n"+
"      <thead><tr><th></th><th class=\"th-time\">Time</th><th class=\"th-km\">Km</th><th>Action</th></tr></thead>\n"+
"      <tbody id=\"nl-table-body\"></tbody>\n"+
"    </table>\n"+
"    <div class=\"water-note\" id=\"nl-water-note\" style=\"display:none\"></div>\n"+
"    <div class=\"n47-cta\">\n"+
"      <div class=\"n47-cta-text\">Fill your flask with <strong id=\"nl-cta-ml\">—</strong> ml N47 before the start.</div>\n"+
"      <button class=\"btn-cta\" id=\"nl-btn-order\">Order N47 →</button>\n"+
"    </div>\n"+
"  </div>\n"+
"  <div class=\"footer\">nectarlab.dk — N47: 1g CHO = 1.07ml · 200mg Na + 50mg K per 30g CHO/hr</div>\n"+
"</div>";

var host = document.getElementById('nl-root');
var shadow = host.attachShadow({mode:'open'});
var sEl = document.createElement('style'); sEl.textContent = css; shadow.appendChild(sEl);
var wEl = document.createElement('div'); wEl.innerHTML = html; shadow.appendChild(wEl);

function q(id){return shadow.getElementById(id);}
function qa(sel){return shadow.querySelectorAll(sel);}
function getOn(id){var el=shadow.getElementById(id);if(!el)return null;var a=el.querySelector('button.on');return a?a.getAttribute('data-val'):null;}
function fmtHM(m){var h=Math.floor(m/60),rest=m-h*60,mm=Math.floor(rest),ss=Math.round((rest-mm)*60);return h+':'+(mm<10?'0':'')+mm+':'+(ss<10?'0':'')+ss;}
function round1(n){return Math.round(n*10)/10;}

/* Tooltips */
q('tip-strategy').textContent = TOOLTIPS.strategy;
q('tip-aid').textContent      = TOOLTIPS.aid;
q('tip-temp').textContent     = TOOLTIPS.temp;
q('tip-gut').textContent      = TOOLTIPS.gut;

shadow.querySelectorAll('.tip-btn').forEach(function(btn){
  btn.addEventListener('click', function(e){
    e.stopPropagation();
    var key = btn.getAttribute('data-tip');
    var box = q('tip-'+key);
    var isOpen = box.classList.contains('show');
    shadow.querySelectorAll('.tip-box').forEach(function(b){b.classList.remove('show');});
    if(!isOpen) box.classList.add('show');
  });
});
document.addEventListener('click', function(){
  shadow.querySelectorAll('.tip-box').forEach(function(b){b.classList.remove('show');});
});

/* Aid stations */
var aidKms=[];
function renderAidTags(){
  var list=q('nl-aid-list'); list.innerHTML='';
  aidKms.slice().sort(function(a,b){return a-b;}).forEach(function(km){
    var tag=document.createElement('div'); tag.className='aid-tag';
    tag.innerHTML='km '+km+' <button data-km="'+km+'">×</button>';
    tag.querySelector('button').addEventListener('click',function(){
      aidKms=aidKms.filter(function(k){return k!==km;}); renderAidTags();
    });
    list.appendChild(tag);
  });
}
q('nl-aid-btn').addEventListener('click',function(){
  var v=parseFloat(q('nl-aid-input').value);
  if(isNaN(v)||v<=0)return;
  if(aidKms.indexOf(v)===-1)aidKms.push(v);
  q('nl-aid-input').value=''; renderAidTags();
});
q('nl-aid-input').addEventListener('keydown',function(e){if(e.key==='Enter')q('nl-aid-btn').click();});

/* Dist buttons */
function updateDistButtons(sport){
  qa('#nl-dist button').forEach(function(b){
    var bs=b.getAttribute('data-sport');
    b.style.display=(bs===sport)?'':'none';
    if(bs!==sport)b.classList.remove('on');
  });
  var first=shadow.querySelector('#nl-dist button[data-sport="'+sport+'"]');
  if(first)first.classList.add('on');
  var val=getOn('nl-dist');
  q('nl-custom-km-wrap').style.display=(val==='custom_run'||val==='custom_cycle'||sport==='cycle')?'block':'none';
  updatePaceHint();
}
shadow.getElementById('nl-sport').querySelectorAll('button').forEach(function(btn){
  btn.addEventListener('click',function(){
    qa('#nl-sport button').forEach(function(b){b.classList.remove('on');}); btn.classList.add('on');
    updateDistButtons(btn.getAttribute('data-val'));
  });
});
shadow.getElementById('nl-dist').querySelectorAll('button').forEach(function(btn){
  btn.addEventListener('click',function(){
    qa('#nl-dist button').forEach(function(b){b.classList.remove('on');}); btn.classList.add('on');
    var val=btn.getAttribute('data-val');
    q('nl-custom-km-wrap').style.display=(val==='custom_run'||val==='custom_cycle')?'block':'none';
    updatePaceHint();
  });
});
qa('.seg').forEach(function(seg){
  if(seg.id==='nl-sport'||seg.id==='nl-dist')return;
  seg.querySelectorAll('button').forEach(function(btn){
    btn.addEventListener('click',function(){
      seg.querySelectorAll('button').forEach(function(b){b.classList.remove('on');}); btn.classList.add('on');
    });
  });
});

function getActualDist(){
  var sport=getOn('nl-sport')||'run';
  var distVal=getOn('nl-dist')||'halfmarathon';
  if(distVal==='custom_run'||distVal==='custom_cycle'){
    var km=parseFloat(q('nl-custom-km').value); return isNaN(km)?null:km;
  }
  var table=RACES[sport]||RACES['run'];
  var entry=table[distVal]; return entry?entry.dist:null;
}
function getRaceLabel(){
  var sport=getOn('nl-sport')||'run';
  var distVal=getOn('nl-dist')||'halfmarathon';
  if(distVal==='custom_run'||distVal==='custom_cycle'){
    var km=parseFloat(q('nl-custom-km').value); return isNaN(km)?'Custom':km+'km';
  }
  var table=RACES[sport]||RACES['run'];
  return(table[distVal]&&table[distVal].label)||'';
}
function updatePaceHint(){
  var h=parseInt(q('nl-hours').value)||0,m=parseInt(q('nl-mins').value)||0,tot=h*60+m;
  var dist=getActualDist(),sport=getOn('nl-sport')||'run';
  if(!tot||!dist){q('nl-pace-hint').textContent='';return;}
  if(sport==='cycle'||sport==='tri'){
    q('nl-pace-hint').textContent='→ '+round1(dist/(tot/60))+' km/h avg';
  } else {
    var p=tot/dist,pm=Math.floor(p),ps=Math.round((p-pm)*60);
    q('nl-pace-hint').textContent='→ '+pm+':'+(ps<10?'0':'')+ps+' min/km';
  }
}
['nl-hours','nl-mins'].forEach(function(id){q(id).addEventListener('input',updatePaceHint);});
q('nl-custom-km').addEventListener('input',updatePaceHint);

function daysToRace(s){if(!s)return null;var t=new Date(s).getTime()-new Date().setHours(0,0,0,0);return Math.ceil(t/86400000);}

var lastPlan=null;

function compute(){
  var name=q('nl-name').value.trim();
  var raceName=q('nl-racename').value.trim();
  var dateStr=q('nl-date').value;
  var sport=getOn('nl-sport')||'run';
  var split=getOn('nl-split')||'even';
  var temp=getOn('nl-temp')||'cool';
  var gut=parseInt(getOn('nl-gut')||'60');
  var hours=parseInt(q('nl-hours').value)||0,mins=parseInt(q('nl-mins').value)||0;
  var totalMin=hours*60+mins;
  if(totalMin<5){alert('Please enter a valid finish time.');return;}
  var dist=getActualDist();
  if(!dist){alert('Please enter a distance.');return;}
  var raceLabel=getRaceLabel(),raceHrs=totalMin/60;

  var tempMult={cool:1.0,warm:1.10,hot:1.15}[temp];
  var rawCHO=gut*tempMult,choPerHr=Math.round(rawCHO),warn=rawCHO>gut;

  var paceMinPerKm=totalMin/dist,kmPerHr=dist/raceHrs;

  function kmAtMin(t){
    if(split==='even')return(t/totalMin)*dist;
    var halfTime=totalMin/2,pFirst=paceMinPerKm*1.02,pSecond=paceMinPerKm*0.98;
    var d1=halfTime/pFirst;
    if(t<=halfTime)return t/pFirst; else return d1+(t-halfTime)/pSecond;
  }
  function minAtKm(km){
    if(split==='even')return(km/dist)*totalMin;
    var lo=0,hi=totalMin;
    for(var i=0;i<50;i++){var mid=(lo+hi)/2;if(kmAtMin(mid)<km)lo=mid;else hi=mid;}
    return(lo+hi)/2;
  }

  var MIN_GEL_GAP=20;
  var aids=aidKms.slice().sort(function(a,b){return a-b;});
  var gels=[];

  if(aids.length>0){
    var candidates=[];
    aids.forEach(function(aidKm){
      var gelKm=Math.max(0,Math.round((aidKm-0.3)*10)/10);
      var gelMin=minAtKm(gelKm);
      if(gelMin>=20&&gelKm<dist)candidates.push({km:gelKm,min:gelMin,type:'aid',aidKm:aidKm});
    });
    candidates.sort(function(a,b){return a.min-b.min;});
    var lastGelMin=-999;
    candidates.forEach(function(c){
      if(c.min-lastGelMin>=MIN_GEL_GAP){gels.push(c);lastGelMin=c.min;}
    });
  }
  gels.sort(function(a,b){return a.km-b.km;});

  function fillGaps(){
    var filled=false;
    for(var i=0;i<=gels.length;i++){
      var prevMin=i===0?20:gels[i-1].min;
      var nextMin=i===gels.length?totalMin:gels[i].min;
      if(nextMin-prevMin>35){
        var insertMin=prevMin+Math.floor((nextMin-prevMin)/2);
        var insertKm=round1(kmAtMin(insertMin));
        if(insertKm<dist){gels.splice(i,0,{km:insertKm,min:insertMin,type:'standalone'});filled=true;break;}
      }
    }
    if(filled)fillGaps();
  }

  if(gels.length===0){
    var interval=choPerHr>=80?20:choPerHr>=60?25:30;
    var t=20;
    while(t<totalMin-2){
      var km=round1(kmAtMin(t));
      if(km<dist)gels.push({km:km,min:t,type:'standalone'});
      t+=interval;
    }
  } else { fillGaps(); }

  var totalDoses=gels.length+1;
  var totalCHO=Math.round(choPerHr*raceHrs);
  var choPerDose=Math.round(totalCHO/totalDoses);
  var mlPerDose=Math.round(choPerDose*ML_PER_G);
  var totalMl=Math.round(totalCHO*ML_PER_G);
  var naPerHr=Math.round((choPerHr/30)*NA_PER_30G);
  var kPerHr=Math.round((choPerHr/30)*K_PER_30G);

  var days=daysToRace(dateStr);
  var countdown=days!==null?(days===0?'Race day!':days+' days to race day'):'';

  q('nl-res-title').textContent=(name?name+"'s fuel plan":'Your fuel plan')+' — '+(raceName||raceLabel);
  q('nl-res-subtitle').textContent=raceLabel+' · '+fmtHM(totalMin)+(countdown?' · '+countdown:'');
  q('nl-warn').classList.toggle('show',warn);
  q('nl-s-dist').textContent=dist+' km';
  q('nl-s-time').textContent=fmtHM(totalMin);
  q('nl-s-cho').textContent=choPerHr+'g';
  q('nl-t-cho').textContent=totalCHO+'g';
  q('nl-t-ml').textContent=totalMl+'ml';
  q('nl-t-elec').textContent=naPerHr+'Na / '+kPerHr+'K';
  q('nl-cta-ml').textContent=totalMl;

  var events=[];
  events.push({min:PRERACE_MIN,km:null,type:'prerace',label:'Pre-race fuel',detail:'water before start',cho:choPerDose,ml:mlPerDose});
  events.push({min:0,km:0,type:'start',label:'Start',detail:null});
  aids.forEach(function(aidKm){events.push({min:minAtKm(aidKm),km:aidKm,type:'aid',label:'Aid station',detail:null});});
  gels.forEach(function(g,i){
    events.push({min:g.min,km:g.km,type:'gel',label:'Fuel '+(i+1),detail:null,cho:choPerDose,ml:mlPerDose});
  });
  events.push({min:totalMin,km:dist,type:'finish',label:'Finish',detail:null});
  events.sort(function(a,b){return a.min-b.min;});

  var tbody=q('nl-table-body'); tbody.innerHTML='';
  events.forEach(function(ev){
    var tr=document.createElement('tr');
    tr.className=(ev.type==='prerace'?'row-gel':'row-'+ev.type);
    var dotCls=ev.type==='start'?'dot hollow':ev.type==='finish'?'dot hollow':ev.type==='aid'?'dot sm':'dot';
    var dotHtml='<div class="dot-wrap"><div class="'+dotCls+'"></div></div>';
    var timeStr=ev.min<0?'T−'+Math.abs(ev.min)+' min':fmtHM(ev.min);
    var kmStr=(ev.km!==null&&ev.km!==undefined)?'km '+ev.km:'';
    var line1='',line2='';
    if(ev.type==='gel'||ev.type==='prerace'){
      line1=ev.label;
      line2=ev.ml+'ml · '+ev.cho+'g CHO'+(ev.detail?' · '+ev.detail:'');
    } else if(ev.type==='aid'){
      line1='Aid station · km '+ev.km;
    } else if(ev.type==='start'){
      line1='Start';
    } else if(ev.type==='finish'){
      line1='Finish';
    }
    var mainHtml='<span class="main-line1">'+line1+'</span>'+(line2?'<span class="main-line2">'+line2+'</span>':'');
    tr.innerHTML='<td>'+dotHtml+'</td><td class="td-time">'+timeStr+'</td><td class="td-km">'+kmStr+'</td><td class="td-main">'+mainHtml+'</td>';
    tbody.appendChild(tr);
  });

  var waterNoteEl=q('nl-water-note');
  if(aids.length>0){
    var aidList=aids.slice().sort(function(a,b){return a-b;}).map(function(k){return 'km '+k;}).join(', ');
    waterNoteEl.innerHTML='<strong>Water at aid stations:</strong> To reduce GI stress, your fuel doses are placed just before each aid station. Focus on drinking water at: '+aidList+'.';
    waterNoteEl.style.display='block';
  } else {
    waterNoteEl.style.display='none';
  }

  var res=q('nl-results'); res.style.display='block';
  setTimeout(function(){
    try{
      var resRect=res.getBoundingClientRect();
      window.scrollTo({top:window.pageYOffset+resRect.top-20,behavior:'smooth'});
    }catch(e){}
  },80);

  lastPlan={name:name,raceName:raceName,dateStr:dateStr,sport:sport,dist:dist,
    raceLabel:raceLabel,totalMin:totalMin,split:split,temp:temp,gut:gut,
    aids:aidKms.slice(),choPerHr:choPerHr,totalCHO:totalCHO,totalMl:totalMl,
    mlPerDose:mlPerDose,choPerDose:choPerDose,naPerHr:naPerHr,kPerHr:kPerHr,
    events:events,warn:warn};

  try{localStorage.setItem('nectarlab_fuelplan_v1',JSON.stringify(lastPlan));}catch(e){}
  try{
    if(window.location.pathname.indexOf('fuelplan')!==-1){
      var enc=btoa(unescape(encodeURIComponent(JSON.stringify(lastPlan))));
      window.history.replaceState(null,'',window.location.pathname+'?plan='+enc);
    }
  }catch(e){}
}

q('nl-compute').addEventListener('click',compute);

q('nl-btn-print').addEventListener('click',function(){
  if(!lastPlan){window.print();return;}
  var p=lastPlan;
  var fmtHMp=function(m){var h=Math.floor(m/60),rest=m-h*60,mm=Math.floor(rest),ss=Math.round((rest-mm)*60);return h+':'+(mm<10?'0':'')+mm+':'+(ss<10?'0':'')+ss;};
  var rows=p.events.map(function(ev){
    if(ev.type==='start'||ev.type==='aid')return '';
    var t=ev.min<0?'T&minus;'+Math.abs(ev.min)+' min':fmtHMp(ev.min);
    var isFinish=ev.type==='finish';
    var dotStyle=isFinish
      ?'width:7px;height:7px;border-radius:50%;border:1.5px solid #000;display:inline-block'
      :'width:7px;height:7px;border-radius:50%;background:#000;display:inline-block';
    var label=ev.label||(isFinish?'Finish':'');
    var badge=ev.cho?'<span style="font-size:10px;color:#666;font-family:monospace;margin-top:3px;display:block">'+ev.ml+'ml &middot; '+ev.cho+'g CHO'+(ev.detail?' &middot; '+ev.detail:'')+'</span>':'';
    return '<tr><td style="width:14px;padding:12px 10px 12px 0;vertical-align:middle"><span style="'+dotStyle+'"></span></td>'
      +'<td style="font-family:monospace;font-size:11px;color:#888;padding:12px 16px 12px 0;white-space:nowrap;border-bottom:1px solid #eee;vertical-align:top">'+t+'</td>'
      +'<td style="font-size:13px;padding:12px 0;border-bottom:1px solid #eee;vertical-align:top">'+label+badge+'</td></tr>';
  }).join('');
  var aidNote='';
  if(p.aids&&p.aids.length>0){
    var aidList=p.aids.slice().sort(function(a,b){return a-b;}).map(function(k){return 'km '+k;}).join(', ');
    aidNote='<div style="margin-top:20px;padding:12px 16px;background:#f8f8f8;border:1px solid #e8e8e8;font-size:11px;color:#555;line-height:1.6"><strong style="color:#111">Water at aid stations:</strong> Fuel doses are placed just before each station. Drink water at: '+aidList+'.</div>';
  }
  var doc='<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>'
    +(p.name?p.name+"'s fuel plan":'Fuel Plan')+(p.raceName?' \u2014 '+p.raceName:'')
    +'</title><style>'
    +'*{margin:0;padding:0;box-sizing:border-box}'
    +'body{font-family:Helvetica,Arial,sans-serif;font-size:13px;color:#111;max-width:640px;margin:32px auto;padding:0 24px;line-height:1.5}'
    +'h1{font-weight:300;font-size:22px;margin-bottom:3px}'
    +'.sub{color:#888;font-size:11px;margin-bottom:28px;font-family:monospace}'
    +'.strip{display:grid;grid-template-columns:repeat(3,1fr);border:1px solid #ddd;margin-bottom:28px}'
    +'.si{padding:14px 12px;border-right:1px solid #ddd}'
    +'.si:last-child{border-right:none}'
    +'.sv{font-size:18px;font-weight:300;margin-bottom:4px;font-family:monospace}'
    +'.sl{font-size:8px;letter-spacing:.1em;text-transform:uppercase;color:#999}'
    +'table{width:100%;border-collapse:collapse;margin-bottom:4px}'
    +'th{font-size:8px;letter-spacing:.12em;text-transform:uppercase;color:#999;padding:0 0 10px;text-align:left;border-bottom:1px solid #ddd}'
    +'.cta{margin-top:20px;padding:12px 16px;background:#f8f8f8;border:1px solid #e8e8e8;font-size:11px;color:#555}'
    +'.footer{margin-top:24px;font-size:9px;color:#bbb;text-align:center;border-top:1px solid #eee;padding-top:12px}'
    +'@media print{@page{margin:1.5cm}}'
    +'</style></head><body>'
    +'<h1>'+(p.name?p.name+"'s fuel plan":'Fuel Plan')+(p.raceName?' \u2014 '+p.raceName:'')+'</h1>'
    +'<div class="sub">'+p.raceLabel+' &middot; '+fmtHMp(p.totalMin)+'</div>'
    +'<div class="strip">'
      +'<div class="si"><div class="sv">'+p.dist+'km</div><div class="sl">Distance</div></div>'
      +'<div class="si"><div class="sv">'+fmtHMp(p.totalMin)+'</div><div class="sl">Finish time</div></div>'
      +'<div class="si"><div class="sv">'+p.choPerHr+'g</div><div class="sl">CHO / hr</div></div>'
      +'<div class="si"><div class="sv">'+p.totalCHO+'g</div><div class="sl">Total CHO</div></div>'
      +'<div class="si"><div class="sv">'+p.totalMl+'ml</div><div class="sl">N47 total</div></div>'
      +'<div class="si"><div class="sv" style="font-size:14px">'+p.naPerHr+'Na / '+p.kPerHr+'K</div><div class="sl">mg / hr</div></div>'
    +'</div>'
    +'<table><thead><tr><th style="width:14px"></th><th style="width:80px">Time</th><th>Action</th></tr></thead><tbody>'+rows+'</tbody></table>'
    +aidNote
    +'<div class="cta">Fill your flask with <strong>'+p.totalMl+'ml N47</strong> before the start &mdash; nectarlab.dk</div>'
    +'<div class="footer">nectarlab.dk &nbsp;&middot;&nbsp; N47: 1g CHO = 1.07ml &middot; 200mg Na + 50mg K per 30g CHO/hr</div>'
    +'</body></html>';
  var w=window.open('','_blank','width=800,height=900');
  w.document.write(doc);
  w.document.close();
  w.focus();
  setTimeout(function(){w.print();},400);
});

q('nl-btn-copy').addEventListener('click',function(){
  var url=window.location.href,btn=q('nl-btn-copy');
  if(navigator.clipboard){
    navigator.clipboard.writeText(url).then(function(){btn.textContent='Copied ✓';setTimeout(function(){btn.textContent='Copy link';},2000);});
  } else {
    var ta=document.createElement('textarea');ta.value=url;document.body.appendChild(ta);ta.select();document.execCommand('copy');document.body.removeChild(ta);
    btn.textContent='Copied ✓';setTimeout(function(){btn.textContent='Copy link';},2000);
  }
});

q('nl-btn-download').addEventListener('click',function(){
  if(!lastPlan)return;
  var p=lastPlan;
  var fmtHMd=function(m){var h=Math.floor(m/60),rest=m-h*60,mm=Math.floor(rest),ss=Math.round((rest-mm)*60);return h+':'+(mm<10?'0':'')+mm+':'+(ss<10?'0':'')+ss;};
  var rows=p.events.filter(function(ev){return ev.type==='gel'||ev.type==='prerace';}).map(function(ev){
    var t=ev.min<0?'T−'+Math.abs(ev.min)+' min':fmtHMd(ev.min);
    return '<tr><td>'+t+'</td><td>'+(ev.km!==null?'km '+ev.km:'—')+'</td><td>'+ev.label+'</td><td>'+ev.ml+'ml · '+ev.cho+'g CHO</td></tr>';
  }).join('');
  var doc='<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>'+(p.name?p.name+"'s fuel plan":'Fuel Plan')+(p.raceName?' — '+p.raceName:'')+'</title>'+
    '<style>body{font-family:Helvetica,Arial,sans-serif;font-size:12px;color:#111;max-width:680px;margin:32px auto;padding:0 24px;line-height:1.6}h1{font-weight:300;font-size:20px;margin-bottom:4px}.sub{color:#888;font-size:11px;margin-bottom:24px}.strip{display:flex;border:1px solid #ddd;margin-bottom:24px}.si{flex:1;padding:12px;text-align:center;border-right:1px solid #ddd}.si:last-child{border-right:none}.sv{font-size:18px;font-weight:300;margin-bottom:3px}.sl{font-size:8px;letter-spacing:.1em;text-transform:uppercase;color:#999}table{width:100%;border-collapse:collapse;margin-bottom:20px}th{font-size:8px;letter-spacing:.12em;text-transform:uppercase;color:#999;padding:5px 8px;border-bottom:1px solid #ddd;text-align:left}td{padding:8px 8px;border-bottom:1px solid #f0f0f0;font-size:12px;vertical-align:top}.cta{background:#f8f8f8;border:1px solid #e8e8e8;padding:12px;font-size:11px;color:#555}.footer{margin-top:28px;font-size:9px;color:#bbb;text-align:center;border-top:1px solid #eee;padding-top:12px}</style></head><body>'+
    '<h1>'+(p.name?p.name+"'s fuel plan":'Fuel Plan')+(p.raceName?' — '+p.raceName:'')+'</h1>'+
    '<div class="sub">'+p.raceLabel+' · '+fmtHMd(p.totalMin)+'</div>'+
    '<div class="strip"><div class="si"><div class="sv">'+p.dist+'km</div><div class="sl">Distance</div></div><div class="si"><div class="sv">'+fmtHMd(p.totalMin)+'</div><div class="sl">Finish time</div></div><div class="si"><div class="sv">'+p.choPerHr+'g</div><div class="sl">CHO/hr</div></div><div class="si"><div class="sv">'+p.totalMl+'ml</div><div class="sl">N47 total</div></div></div>'+
    '<table><thead><tr><th>Time</th><th>Km</th><th>Action</th><th>Dose</th></tr></thead><tbody>'+rows+'</tbody></table>'+
    '<div class="cta">Fill your flask with <strong>'+p.totalMl+'ml N47</strong> before the start — nectarlab.dk</div>'+
    '<div class="footer">nectarlab.dk — N47: 1g CHO = 1.07ml · 200mg Na + 50mg K per 30g CHO/hr</div>'+
    '</body></html>';
  var blob=new Blob([doc],{type:'text/html'});
  var url=URL.createObjectURL(blob);
  var a=document.createElement('a');a.href=url;
  a.download=(p.name?p.name.replace(/\s+/g,'-').toLowerCase()+'-':'')+(p.raceName?p.raceName.replace(/\s+/g,'-').toLowerCase()+'-':'')+'fuelplan.html';
  document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);
});

q('nl-btn-order').addEventListener('click',function(){
  window.location.href='https://nectarlab.dk/collections/all?ref=fuelplan&ml='+(lastPlan?lastPlan.totalMl:100);
});

(function(){
  var saved;
  try{
    var urlParams=new URLSearchParams(window.location.search),pp=urlParams.get('plan');
    if(pp)saved=JSON.parse(decodeURIComponent(escape(atob(pp))));
    else saved=JSON.parse(localStorage.getItem('nectarlab_fuelplan_v1'));
  }catch(e){}
  if(!saved)return;
  var bar=q('nl-restore');
  q('nl-restore-name').textContent=saved.name||saved.raceName||'previous plan';
  bar.classList.add('show');
  q('nl-restore-yes').addEventListener('click',function(){
    bar.classList.remove('show');
    function setOn(sid,val){qa('#'+sid+' button').forEach(function(b){b.classList.toggle('on',b.getAttribute('data-val')===val);});}
    if(saved.name)q('nl-name').value=saved.name;
    if(saved.raceName)q('nl-racename').value=saved.raceName;
    if(saved.dateStr)q('nl-date').value=saved.dateStr;
    if(saved.totalMin){q('nl-hours').value=Math.floor(saved.totalMin/60);q('nl-mins').value=Math.round(saved.totalMin%60);}
    if(saved.aids){aidKms=saved.aids;renderAidTags();}
    if(saved.sport){setOn('nl-sport',saved.sport);updateDistButtons(saved.sport);}
    if(saved.split)setOn('nl-split',saved.split);
    if(saved.temp)setOn('nl-temp',saved.temp);
    if(saved.gut)setOn('nl-gut',String(saved.gut));
    updatePaceHint();
    compute();
  });
  q('nl-restore-no').addEventListener('click',function(){
    bar.classList.remove('show');
    try{localStorage.removeItem('nectarlab_fuelplan_v1');}catch(e){}
    try{if(window.location.pathname.indexOf('fuelplan')!==-1)window.history.replaceState(null,'',window.location.pathname);}catch(e){}
  });
})();

updatePaceHint();

})();
});